import React, { Fragment } from 'react';
import '../assets/styles/output.css';
import BillDetails from '../components/ShoppingCart/BillDetails/BillDetails';
import CartItem from '../components/ShoppingCart/CartItem/CartItem';
import Navbar from '../components/Navbar/Navbar';
import { useSelector } from 'react-redux';

export default function Cart() {
    const items = useSelector((state) => state.cart.cartItems);
    return (
        <Fragment>
            <Navbar />
            <main className="py-16">
                <div className="container 2xl:px-8 px-2 mx-auto">
                    <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
                    <div className="cartListContainer">
                        <div className="space-y-6">
                            {/* <!-- Cart Item --> */}
                            {items.map((item) => (
                                <CartItem item = {item} key={item.id} />
                            ))}

                        </div>

                        {/* <!-- Bill Details --> */}
                        <BillDetails />
                    </div>
                </div>
            </main>
        </Fragment>
    )
}
